import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useMemo } from 'react';
import isEqual from 'react-fast-compare';
import keyBy from 'lodash/keyBy';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useTorpedoLayout } from './hooks/useTorpedoLayout';
import { didItemsChange } from './helpers';
import TorpedoRow from './_partials/TorpedoRow';
import s from './BaseTorpedo.scss';
const BaseTorpedo = (props)=>{
    var _rows;
    const { innerRef, items = [], container, layoutConfig, useCardLayout, maxRows, hideIncompleteRows, enableScrollVisibilityOptimisation, contentStrip, contentStripOffset = 0, renderItem, onOffsetReached, testRenderSpy, testRecalculateLayoutSpy } = props;
    const { rows, styleParams } = useTorpedoLayout({
        items,
        container,
        layoutConfig,
        useCardLayout,
        maxRows,
        hideIncompleteRows,
        testRecalculateLayoutSpy
    });
    useDebugRerenders('BaseTorpedo', _object_spread_props(_object_spread({}, props), {
        rows,
        styleParams
    }));
    const dataItemDictionary = useMemo(()=>keyBy(items, (item)=>item.id), [
        items
    ]);
    if (!((_rows = rows) === null || _rows === void 0 ? void 0 : _rows.length)) {
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "BaseTorpedo"
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['root'],
            ref: innerRef
        }));
    }
    // Remove the outer gutter, this works by root having
    // overflow:hidden and width set to container.width
    const wrapMargins = {
        marginLeft: `-${styleParams.itemSpacing}px`,
        marginTop: `-${styleParams.itemSpacing}px`,
        marginBottom: `-${styleParams.itemSpacing}px`
    };
    testRenderSpy && testRenderSpy();
    var _row_extraItemHeight;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "BaseTorpedo"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        ref: innerRef,
        style: {
            width: container.width
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: wrapMargins
    }, rows.map((row)=>/*#__PURE__*/ React.createElement(TorpedoRow, {
            key: row.idx,
            idx: row.idx,
            width: row.width,
            height: row.height + ((_row_extraItemHeight = row.extraItemHeight) !== null && _row_extraItemHeight !== void 0 ? _row_extraItemHeight : 0),
            layoutItems: row.items,
            dataItems: dataItemDictionary,
            contentStrip: (row.idx === contentStripOffset + 1 || rows.length <= contentStripOffset && row.idx === rows.length) && contentStrip,
            scrollOptims: enableScrollVisibilityOptimisation,
            onOffsetReached: onOffsetReached,
            renderItem: renderItem
        })))));
};
BaseTorpedo.displayName = 'BaseTorpedo';
export default /*#__PURE__*/ React.memo(BaseTorpedo, (_param, _param1)=>{
    var { items: prevItems } = _param, prevProps = _object_without_properties(_param, [
        "items"
    ]), { items: nextItems } = _param1, nextProps = _object_without_properties(_param1, [
        "items"
    ]);
    if (didItemsChange(prevItems, nextItems)) {
        return false;
    }
    return isEqual(prevProps, nextProps);
});
